import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import globalStyles from './pc-pager.lightDom.css.lit';

/**
 * Pager component
 * @element pc-pager
 * @slot - This element has a default slot
 */
@customElement('pc-pager')
export class PCPager extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-pager': PCPager;
  }
}
